import React from "react";
import LookupManagerPage from "./LookupManagerPage";

function ImplementorsPage() {
  return (
    <LookupManagerPage
      title="Implementors"
      endpoint="/implementors"
      createPath="/implementors/new"
      editPathBase="/implementors"
      fields={[
        { name: "name", label: "Name" },
        { name: "contact", label: "Contact", required: false },
        { name: "focalperson", label: "Focal person", required: false }
      ]}
    />
  );
}

export default ImplementorsPage;
